// UserUnlockPopup.js
function UserUnlockPopup({ show, onClose, onUnlockUser }) {
  const handleSubmit = () => {
    onUnlockUser(); // Pass the unlock user back to the parent
    onClose(); // Close the popup
  };

  const handleCancel = () => {
    onClose(); // Close the popup
  };

  if (!show) return null; // Render nothing if `show` is false

  return (
    <>
      {/* Overlay for background blur */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent dark overlay
          backdropFilter: "blur(5px)", // Apply blur effect
          zIndex: 1, // Ensure overlay is behind the popup
        }}
        onClick={onClose}
      />

      {/* Popup Window */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          backgroundColor: "white",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
          zIndex: 2, // Ensure popup is above the overlay
        }}
      >
        <h5>Unlock your user</h5>
        <div>Unlock your user if you cannot reset or change your password.</div>
        <div>
          <button onClick={handleSubmit}>OK</button>
          <button onClick={handleCancel}>Cancel</button>
        </div>
      </div>
    </>
  );
}

export default UserUnlockPopup;
